import React from 'react';
import AdminRegistration from '../Authentication/AdminRegistration';

// Admin settings now leverage the shared Super Admin registration experience.
// This keeps the admin utilities consistent and avoids maintaining duplicate UIs.
const AdminSettings = () => {
  return <AdminRegistration />;
};

export default AdminSettings;
